"use client"

import { MintingNow } from "@/app/components/minting-now"
import { VerifiedIcon } from "@/app/icons/verified"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import {
  useCollectionReatom,
  useCollectionStatisticReatom,
} from "../../store/use-collection.reatom"
import { CollectionImage } from "../../view/collection-image"
import { CollectionContract } from "./collection-contract"
import { CollectionLinks } from "./links"
import { ShareCollection } from "./share-collection"

function CollectionOverviewLayout(props: {
  image: React.ReactNode
  title: React.ReactNode
  subtitle: React.ReactNode
}) {
  return (
    <div className="flex items-center gap-4 overflow-hidden">
      {props.image}
      <div className="flex flex-col justify-between gap-1 overflow-hidden">
        {props.title}
        {props.subtitle}
      </div>
    </div>
  )
}

export const CollectionOverviewContentReatom = reatomComponent(() => {
  const collection = useCollectionReatom()
  const statistic = useCollectionStatisticReatom()

  return (
    <CollectionOverviewLayout
      image={
        <CollectionImage
          imageSrc={collection.image}
          collectionName={collection.name}
          className="h-12 w-12"
        />
      }
      title={
        <div className="flex items-center gap-2 overflow-hidden">
          <h3 className="max-w-[450px] flex-shrink overflow-hidden text-ellipsis text-nowrap text-xl">
            {collection.name}
          </h3>
          {collection.verified && (
            <VerifiedIcon className="h-4 w-4 flex-none" />
          )}
          {collection.drop && (
            <MintingNow
              collectionId={collection.id}
              drop={collection.drop}
              items={statistic?.items}
            />
          )}
        </div>
      }
      subtitle={
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <CollectionContract />
          <CollectionLinks
            socialLinks={collection.links}
            scanner={collection.scanner}
          />
          <ShareCollection />
        </div>
      }
    />
  )
})

export function CollectionOverviewSkeletonReatom() {
  return (
    <CollectionOverviewLayout
      image={<Skeleton className="h-12 w-12 rounded-md border" />}
      title={<Skeleton className="h-7 w-[140px]" />}
      subtitle={<Skeleton className="h-6 w-[210px]" />}
    />
  )
}
